import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu.svg'
import _imports_1 from '@/assets/dynematrix.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-eee02fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar bg-white p-0 sticky z-50 top-0 left-0 flex shadow" }
const _hoisted_2 = { class: "w-40" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-4 w-5 cursor-pointer"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lg:flex cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold cursor-pointer" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "",
      class: "w-40"
    })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1 px-2 mx-2" }, null, -1))
const _hoisted_7 = { class: "flex-none" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "m-1 mr-2 w-8 h-8 rounded-full bg-gray text-2xl cursor-pointer"
}
const _hoisted_10 = { class: "flex justify-center items-center h-full text-white cursor-pointer" }
const _hoisted_11 = {
  key: 2,
  class: "py-1 -mt-1 bg-white absolute right-4 shadow card w-60"
}
const _hoisted_12 = { class: "py-2 text-gray cursor-pointer flex flex-col items-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "m-1 mr-2 w-12 h-12 rounded-full bg-gray text-2xl cursor-pointer"
}
const _hoisted_16 = { class: "flex justify-center items-center h-full text-white cursor-pointer" }
const _hoisted_17 = { class: "px-4 text-base mt-1" }
const _hoisted_18 = { class: "px-4 text-xs mt-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey w-full mt-2" }, null, -1))
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 3,
  class: "inline-block invisible"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey w-full" }, null, -1))
const _hoisted_23 = { class: "flex justify-center items-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "lg:flex mx-2 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ontoggle()))
      }, _hoisted_4),
      _hoisted_5
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showBlock = !_ctx.showBlock))
      }, [
        (_ctx.userInfo.picture)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.userInfo.picture,
              class: "rounded-full m-1 mr-2 w-8 h-8 cursor-pointer"
            }, null, 8, _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getUserName()), 1)
            ])),
        (_ctx.showBlock)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.userInfo.picture)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: _ctx.userInfo.picture,
                        class: "rounded-full m-1 mr-2 w-12 h-12 cursor-pointer"
                      }, null, 8, _hoisted_14)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getUserName()), 1)
                    ])),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.userInfo.name), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.userInfo.email), 1),
                _hoisted_19,
                (_ctx.displayName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.displayName), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_21, "DisplayName")),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "filterButton flex mt-1",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                  }, " Log Out ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}